import Index from 'src/pages/Settings/Index.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/settings',
    name: 'Allgemeines',
    component: Index,
    meta: { ...auth, ...notUser }
  }
]
